import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

type BaseMetricLabel =
  | 'Sales'
  | 'Book'
  | 'Earnings'
  | 'Forecasted Earnings in 12m'
  | 'Forecasted Sales in 12m';

export const useBaseMetricLabel = () => {
  const t = useValuationTranslation();
  return (metricLabel: BaseMetricLabel) => {
    switch (metricLabel) {
      case 'Sales':
        return t('keyMetric.psBaseMetric');
      case 'Book':
        return t('keyMetric.pbBaseMetric');
      case 'Forecasted Earnings in 12m':
        return t('keyMetric.forwardPEBaseMetric');
      case 'Forecasted Sales in 12m':
        return t('keyMetric.forwardPSBaseMetric');
      case 'Earnings':
        return t('keyMetric.peBaseMetric');
    }
  };
};
